<template>
  <div class="bg-warning-soft py-4 px-4 md:px-8">
    <header class="mb-2">
      <h4 class="text-xl font-bold">Acceso para el acompañante</h4>
      <p class="text-slate-700 leading-tight">El acceso a las instalaciones se realizará mediante tarjeta y opcionalmente podrá configurar el reconocimiento facial a través de este equipo.</p>
    </header>
    <base-message-box>
      <template slot="content">
        <p>
          El sistema de reconocimiento facial está siendo habilitado. Podrá acceder al Club haciendo uso del mismo en el
          momento que reciba la confirmación a través del correo electrónico vinculado a su cuenta de usuaria/o.
        </p>
      </template>
    </base-message-box>
  </div>
</template>

<script>
export default {
  name: 'BiometricAccessPending'
}
</script>
